import React, { useRef, useCallback, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Button, Input, Select, Form, ToggleSwitch } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Grid, Box } from '@mui/material';
import IconPicker from 'Modules/.common/components/IconPicker';
import { NotificationManager } from 'Components/Notifications';
import Tabs, { TabContainer } from 'Components/Tabs';
import { OrderData } from 'Core/data/Helpers';
import { convertWhiteColor } from 'Core/data/Helpers'
import { findColor } from 'Components/Map/utils'

//actions
import {
    clearRedux,
    mapGeofenceBulkOpenModal,
    mapGeofenceBulkUpdate,
    mapGetGeofenceTagsToCreate,
    mapGetGeofenceTags
} from 'Redux/actions';

const GeofenceBulk = (props) => {

    const { intl, mapRef } = props;
    const { messages } = intl;

    const [formData, setFormData] = useState({ color: '8677D9' });
    const [groups, setGroups] = useState([]);
    const dispatch = useDispatch();
    const editGeofenceBulk = useRef();

    const { 
        open,
        geofencesToBulk,
        loadingGeofenceBulk,
        response } = useSelector((state) => state.realtimeMapGeofenceBulkModuleRedux);

    const { geofenceTagsToCreate: geofenceTags, geofenceTagsToCreateLoading: geofenceTagsLoading } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);

    useEffect(()=> {
        dispatch(mapGetGeofenceTagsToCreate())
    },[])

    useEffect(()=> {
        if(open && geofenceTags && geofenceTags.length > 0){
            let groupsList = []
            geofenceTags.forEach((group)=> {
                groupsList.push({
                    ...group, 
                    count: 0,
                    countDefault: 0,
                    color : !group.color ? '#DEDEDE' : convertWhiteColor(group.color),
                    default: true
                })
            })

            if(geofencesToBulk){
                groupsList = loadGefenceGroups(groupsList)                
                setFormData({ ...formData, geofencesIds: geofencesToBulk.map((item) => item.id) })
            }
                

            setGroups(groupsList)
        }
    }, [geofenceTags, geofencesToBulk])

    useEffect(()=> {
        if(response){
            NotificationManager.success(
                messages['mapGeofenceBulk_geofence'],
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            dispatch(mapGeofenceBulkOpenModal(false))
        }
    },[response])


    const loadGefenceGroups = (groupsList) => {

        let listResponse = [...groupsList]
        geofencesToBulk.forEach((geofence) => {
            const { tagsId } = geofence
            if(tagsId){
                const splitGroups = tagsId.split(',')

                splitGroups.forEach((group) => {
                    let listElement = listResponse.find((item) => item.id == parseInt(group))
                    if(listElement){
                        const countElements = listElement.count + 1
                        listElement.count = countElements
                        listElement.countDefault = countElements
                    }    
                })
                
            }    
        })
        
        listResponse = listResponse.map((group) => {
            if(group.count > 0){
                return {
                    ...group,
                    name: `${group.label} (${group.count})`,
                    default: false
                }
            }
            return group
            
        })
        return listResponse
            
    }

    const removeOfList = (newList) => {
        const idsToActive = newList.map((item) => item.id)
        const newListToReturn = groups.map((item) => {
            if(!idsToActive.includes(item.id)){
                return {
                    ...item,
                    name: item.label,
                    count : 0,
                    default: true
                }
            }else{
                if(item.count == 0)
                    return {
                        ...item,
                        name: `${item.label} (${geofencesToBulk.length})`,
                        count: geofencesToBulk.length,
                        default: false
                    }
                return {
                    ...item,
                    name: `${item.label} (${item.count})`,
                    default: false
                }
            }
        })
        setGroups(newListToReturn)
    }

    const handleClose = () => {
        dispatch(mapGeofenceBulkOpenModal(false));
    }

    const onSubmit = useCallback(() => {
        
        const updateBulk = []

        //get the deleted groups
        const getDeletedElements = groups.filter((item) => item.count == 0 && item.countDefault > 0);
        
        getDeletedElements.forEach((group) => {
            updateBulk.push({
                tagId: group.id, 
                name: group.name,
                entityName: 'Geofence', 
                entityIds: geofencesToBulk.map((item) => item.id), 
                action: 'Delete'
            })
        })

        groups.forEach((group) => {
            if(!group.default && group.count != group.countDefault)
                updateBulk.push({
                    tagId: group.id, 
                    name: group.name,
                    entityName: 'Geofence', 
                    entityIds: geofencesToBulk.map((item) => item.id), 
                    action: 'Create'
                })
        })
        
        dispatch(mapGeofenceBulkUpdate(updateBulk, formData && formData.color ? formData : null))
        dispatch(mapGetGeofenceTags())
    })

    return (
        <Modal
            title={`${messages['mapGeofenceBulk_title']} - ${geofencesToBulk.length} ${messages['mapGeofenceBulk_geofence_selected']}`}
            open={open}
            loading={loadingGeofenceBulk || geofenceTagsLoading}
            position="right"
            size="small"
            className="modal-top-0"
            headerStyle={{
                top: 0
            }}
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
                    <Form ref={editGeofenceBulk} onValidSubmit={onSubmit}>
                        <div style={{ marginBottom: 12 }}>    
                            <React.Fragment>
                                <div style={{ width: '100%' }}>
                                    <Grid
                                        container
                                        /* wrap="nowrap" */
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item xs={11}>
                                            <div style={{ padding: '22px 0px 10px 0px' }}>
                                                <label style={{ fontWeight: 'bold' }}>
                                                    {messages['mapGeofenceBulk_Icon_color']}
                                                </label>
                                            </div>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <div className="form-item">
                                                <IconPicker
                                                    color={convertWhiteColor(formData.color).replace('#', '')}
                                                    icon={formData?.iconName}
                                                    options={formData?.geofenceIcon ? ["color", "icon"] : ["color"]}
                                                    onChange={(color, icon) => setFormData({ ...formData, color: findColor(color), iconName: icon })}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div style={{ padding: '22px 0px 10px 0px' }}>
                                                <label>
                                                    {messages['mapGeofenceBulk_selectedGeofences']}
                                                </label>
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Select
                                                id="groupsGeofenceBulk"
                                                label={messages["mapGeofenceBulk_tag"]}
                                                placeholder={messages["select"]}
                                                options={groups.filter((item) => item.default) || []}
                                                valueField="id"
                                                textField="name"
                                                onChange={(value) => {
                                                    let groups = value || [];
                                                    removeOfList(groups);
                                                }}
                                                value={groups.filter((item) => !item.default) || []}
                                                multiple
                                                selectedOptionsBelow
                                                required
                                                requiredMessage={messages["required_field"]}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </React.Fragment>
                        </div>
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loadingGeofenceBulk || geofenceTagsLoading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingGeofenceBulk || geofenceTagsLoading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editGeofenceBulk.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )

}

export default injectIntl(GeofenceBulk);